import React, { useState } from "react";
import Sidebar from "../../../components/Sidebar/Sidebar";
import AdminList from "../../../components/AdminList/AdminList";
import Modal from "../../../components/Modal/Modal";
import { getHoofdbestuur, deleteHoofdbestuur, createHoofdbestuur, updateHoofdbestuur } from "../../../utils/api";

const columns = [
  { key: "name", label: "Name" },
  { key: "position", label: "Function" },
  { key: "phone", label: "Phone" },
  { key: "mobile", label: "Mobile" },
  { 
    key: "createdAt", 
    label: "Created",
    render: (value) => value ? new Date(value).toLocaleDateString() : "-"
  },
];

const filters = [
  {
    key: "position",
    label: "Filter by Function",
    type: "search",
    placeholder: "Search function"
  },
];

const initialFormData = {
  name: "",
  position: "",
  phone: "",
  mobile: ""
};

export default function Hoofdbestuur() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);

  const handleAdd = () => {
    setFormData(initialFormData);
    setIsEditMode(false);
    setSelectedItem(null);
    setModalOpen(true);
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    setFormData({
      name: item.name || "",
      position: item.position || "",
      phone: item.phone || "",
      mobile: item.mobile || ""
    });
    setIsEditMode(true);
    setModalOpen(true);
  };

  const handleView = (item) => {
    handleEdit(item);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isEditMode && selectedItem) {
        await updateHoofdbestuur(selectedItem._id, formData);
        alert("Updated successfully!");
      } else {
        await createHoofdbestuur(formData);
        alert("Created successfully!");
      }
      setModalOpen(false);
    } catch (error) {
      alert(error.message || "Failed to save");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-content">
        <AdminList
          title="Hoofdbestuur"
          fetchData={getHoofdbestuur}
          deleteData={deleteHoofdbestuur}
          columns={columns}
          onEdit={handleEdit}
          onAdd={handleAdd}
          onView={handleView}
          filters={filters}
          searchPlaceholder="Search hoofdbestuur..."
        />
      </main>

      {/* Create/Edit Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        title={isEditMode ? "Edit Hoofdbestuur" : "Add New Hoofdbestuur"}
        size="large"
      >
        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>Basic Information</h3>
            <div className="form-group">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleFormChange}
                required
                placeholder="Enter name"
              />
            </div>
            <div className="form-group">
              <label>Function *</label>
              <input
                type="text"
                name="position"
                value={formData.position}
                onChange={handleFormChange}
                required
                placeholder="Type function or position"
              />
            </div>
          </div>

          <div className="form-section">
            <h3>Contact Information</h3>
            <div className="form-row">
              <div className="form-group">
                <label>Phone</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleFormChange}
                  placeholder="Phone number"
                />
              </div>
              <div className="form-group">
                <label>Mobile</label>
                <input
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleFormChange}
                  placeholder="Mobile number"
                />
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalOpen(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Saving..." : (isEditMode ? "Update" : "Create")}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
